import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ColorExtractorService {
    headerColor: WritableSignal<string> = signal('');
    constructor() {}
}
